import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 12px;
  width: 100%;
  flex: none;
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
`;

export const Title = styled.div`
  width: 100%;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #393939;
`;

export const SubTitle = styled.div`
  width: 100%;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #393939;
`;

// Adapted from InitialVerifications/styles.ts
export const InfoBanner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 4px 8px;
  gap: 10px;
  width: 100%;
  min-height: 40px;
  background: #FFF1D2;
  border-radius: 4px;
  margin-top: 8px;
  box-sizing: border-box;
  
  font-size: 12px;
  line-height: 16px;
  color: #000000;
  font-weight: 400;
  flex: none;

  b {
    font-weight: 700;
  }
`;

export const SectionWithBorder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px;
  gap: 24px;
  border: 1px solid #C8ACFD;
  border-radius: 8px;
  background-color: #ffffff;
  width: 100%;
`;

export const LabelWithIcon = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #393939;
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 19px;
  
  .icon {
    width: 16px;
    height: 16px;
    color: ${props => props.theme.main.color};
    cursor: pointer;
  }
`;

export const InfoSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  width: 100%;
  flex: none;
`;

export const InfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  flex: 1;
`;

export const InfoLabel = styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: #393939;
`;

export const InfoValueBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 16px;
  border-radius: 4px;
`;

export const InfoValueText = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #2B313C;
`;

export const DocumentsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px; 
  gap: 0px;
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #DDDDDD;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 8px;
`;

export const ListHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  gap: 12px;
  width: 100%;
  height: 48px;
  background: #F8F4FF;
  border-bottom: 1px solid #E3E3E3;
`;

export const ListHeaderLabel = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 19px;
  display: flex;
  align-items: center;
  color: #393939;
  
  &.col-name {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
  }
  
  &.col-status {
    width: 112px;
    justify-content: center;
  }
  
  &.col-actions {
    width: 98px;
    justify-content: center;
  }
`;

export const ListItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  gap: 12px;
  width: 100%;
  min-height: 52px;
  background: #FFFFFF;
  border-bottom: 1px solid #E3E3E3;

  &:last-child {
    border-bottom: none;
  }
`;

export const DocumentName = styled.div<{ isRequired?: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: #2B313C;
`;

export const RequiredAsterisk = styled.span`
  color: #FF3B30;
  font-weight: 700;
  margin-left: 2px;
`;

export const RequiredTag = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  background: #FFECEC;
  border: 1px solid #FF3B30;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  color: #FF3B30;
  text-transform: uppercase;
  margin-left: 8px;
`;

export const DocumentIconWrapper = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #59249B;
`;

export const StatusWrapper = styled.div`
  width: 112px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StatusBadge = styled.div<{ status: 'pending' | 'sent' }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 8px;
  gap: 4px;
  height: 24px;
  border-radius: 54px;
  
  background: ${props => props.status === 'sent' ? 'rgba(105, 255, 105, 0.2)' : 'rgba(255, 203, 33, 0.2)'};
`;

export const StatusDot = styled.div<{ status: 'pending' | 'sent' }>`
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: ${props => props.status === 'sent' ? '#69FF69' : '#FFCB21'};
  border: 1px solid ${props => props.status === 'sent' ? '#44C444' : '#FFA742'};
`;

export const StatusText = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #2B313C;
`;

export const ActionsWrapper = styled.div`
  width: 98px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

export const ActionButton = styled.button<{ actionType: 'upload' | 'delete' }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 10px;
  width: 36px;
  height: 36px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  
  background: ${props => props.actionType === 'upload' ? '#00A2DD' : '#FFE3E3'};
  color: ${props => props.actionType === 'upload' ? '#FFFFFF' : '#FF3B30'};
  
  &:hover {
    opacity: 0.9;
  }
`;
